import api from '../axiosConfig';
import { GUESTS } from '../config/apiEndpoints';

export const GuestService = {
    /**
     * Search and retrieve guests with pagination
     * GET /api/v1/guests
     * @param {Object} params - Query params (search, page, limit, noPaging)
     * @param {string} tenantId - Active tenant context
     */
    searchGuests: async (params = {}, tenantId) => {
        try {
            const axiosParams = { ...params };
            
            if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
                delete axiosParams.noPaging;
            } else {
                if (params.page !== undefined) axiosParams.page = params.page;
            }
            
            const response = await api.get(GUESTS.BASE, {
                params: axiosParams,
                headers: { 'x-tenant-id': tenantId }
            });
            const data = response.data;
            return data;
        } catch (error) {
            console.error('GuestService searchGuests error:', error);
            throw error;
        }
    },
    
    /**
     * Create a new guest
     * POST /api/v1/guests
     * @param {Object} guestData - Guest payload
     * @param {string} tenantId - Active tenant context
     */
    createGuest: async (guestData, tenantId) => {
        try {
            const response = await api.post(GUESTS.BASE, guestData, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('GuestService createGuest error:', error);
            throw error;
        }
    },
    
    /**
     * Get guest profile by ID
     * GET /api/v1/guests/{id}
     * @param {string} id - Guest ID
     * @param {string} tenantId - Active tenant context
     */
    getGuestById: async (id, tenantId) => {
        try {
            const response = await api.get(GUESTS.BY_ID(id), {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('GuestService getGuestById error:', error);
            throw error;
        }
    },
    
    /**
     * Update guest profile
     * PATCH /api/v1/guests/{id}
     * @param {string} id - Guest ID
     * @param {Object} guestData - Guest payload to update
     * @param {string} tenantId - Active tenant context
     */
    updateGuest: async (id, guestData, tenantId) => {
        try {
            const response = await api.patch(GUESTS.BY_ID(id), guestData, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('GuestService updateGuest error:', error);
            throw error;
        }
    },

    /**
     * Get guest stay history
     * GET /api/v1/guests/{id}/stay-history
     * @param {string} id - Guest ID
     * @param {string} tenantId - Active tenant context
     */
    getGuestStayHistory: async (id, tenantId) => {
        try {
            const response = await api.get(GUESTS.STAY_HISTORY(id), {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('GuestService getGuestStayHistory error:', error);
            throw error;
        }
    },

    /**
     * Merge Duplicate Guest Profiles
     * POST /api/v1/guests/merge
     * @param {Object} payload - { primaryGuestId, duplicateGuestId, fieldOverrides }
     * @param {string} tenantId - Active tenant context
     */
    mergeGuests: async (payload, tenantId) => {
        try {
            const response = await api.post(GUESTS.MERGE, payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('GuestService mergeGuests error:', error);
            throw error;
        }
    }
};
